import { useTrack, TrackEvents } from '@/composables/useTrack';
import { useToast } from '@/composables/useToast';
import { useIntegrationStore } from '../store/useIntegrationStore';
import { paragon } from '@useparagon/connect';

/**
 * Composable for integration-specific actions and event handling
 * Handles UI interactions, tracking, and user feedback
 */
export const useIntegrationActions = () => {
  const integrationStore = useIntegrationStore();
  const { track } = useTrack();
  const { success } = useToast();

  const toggleIntegration = async (integrationName: string) => {
    try {
      await paragon.connect(integrationName, {
        onSuccess: () => {
          track(TrackEvents.INTEGRATIONS_SETUP, { integration: integrationName });
          success(`${integrationName} integration updated successfully`);
          integrationStore.fetchIntegrations(true);
        },
        onError: (error: any) => {
          console.error('Integration error:', error);
        },
      });
    } catch (error) {
      console.error('Failed to toggle integration:', error);
    }
  };

  const handleRequestEnable = (integrationName: string) => {
    track(TrackEvents.INTEGRATIONS_SETUP_REQUESTED, { integration: integrationName });
    success(`Thanks for your interest in ${integrationName}! We've recorded your request and will follow up with pricing and availability.`, {
      title: 'Integration Request Submitted',
    });
  };

  const handleStaticIntegrationClick = (integration: { name: string; url: string }) => {
    track(TrackEvents.INTEGRATIONS_SETUP, { integration: integration.name });
    window.open(integration.url, '_blank');
  };

  return {
    toggleIntegration,
    handleRequestEnable,
    handleStaticIntegrationClick,
  };
};
